module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team/teachers/jacek-czlonkowski-4bb4a21c660b6efe9c314aa720d69b32.webp";